module.exports = __webpack_public_path__ + "img/exchangeTitle@2x.26cf400c.png";